// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { getVarType } from 'src/lib/utils.js';


// Stateful components

export class ProgressSection extends React.Component{


    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            selected_program: null,
            show_gpa: false
        };

        this.revealGPA = this.revealGPA.bind(this);

    }

    componentDidMount(){
        var this_component = this;
        this_component.getProgramData();
    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;

        // New Program
        var programs_index = this_component['props']['index'];
        if (programs_index !== prev_props['index']) {
            this_component.getProgramData();
        }
    }


    //
    // Events
    //

    revealGPA(e) {
        e.preventDefault();

        var this_component = this;
        var show_gpa = !(this_component['state']['show_gpa']);

        this_component.setState({
            show_gpa: show_gpa
        });
    }

    //
    // Functions
    //

    getProgramData() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var courses_storage = squiz.fn.getStorage('getmycourses', 'session', 'json');

        var programs = courses_storage['data']['programs'];
        var programs_index = this_component['props']['index'];
        var selected_program = programs[programs_index];
        
        if (selected_program) {
            this_component.setState({
                selected_program: selected_program
            });
        }
    }

    renderPlans(program) {
        var academic_plans = Object.keys(program['academicPlans']).map(function (key) {
            return program['academicPlans'][key]
        });

        if (academic_plans) {

            var filtered_plans = academic_plans.filter(function(plan) {
                return plan['name'].length > 0;
            });

            var sorted_plans = filtered_plans.sort(function(a, b) {
                if (a['planType'] < b['planType']) {
                    return -1;
                }
                if (a['planType'] > b['planType']) {
                    return 1;
                }
                return 0;
            });
            
            var grouped_plans = sorted_plans.reduce(function(arr, plan) {
                var plan_type = plan['planType'];

                var obj_with_key = arr.filter(function(item) {
                    return item['plan_type'] === plan_type;
                });

                if (obj_with_key.length > 0) {
                    obj_with_key[0]['plans'].push(plan);
                } else {
                    arr.push({
                        plan_type: plan_type,
                        plans: [].concat(plan)
                    });
                }
                
                return arr;
            }, []);

            return grouped_plans.map(function(plan_group) {
                
                var plan_type = plan_group['plan_type'];
                var plan_names = plan_group['plans'].map(function(plan) {
                    return plan['name'];
                });
                
                return (
                    <div key={plan_type} className="my-program-major__item">
                        <div className="my-program-major__item__title">
                            {plan_type}
                        </div>
                        <div className="my-program-major__item__details">
                            {plan_names.join(', ')}
                        </div>
                    </div>
                );
            });
        }
    }

    renderMajorInfo() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var selected_program = this_component['state']['selected_program'];
        
        if (selected_program) {
            var change_major_url = helpers.getDynamicLinkUrlById('889844');
            var plans = this_component.renderPlans(selected_program);
            
            if (plans) {
                if (plans.length > 0) {
                    return (
                        <div className="my-program-major__wrapper">
                            <div className="my-program-major__items">
                                {plans}
                            </div>
                            <a href={change_major_url} className="my-program-major__change-button">
                                <span className="my-program-major__change-button__text">
                                    Change
                                </span>
                                <span className="my-program-major__change-button__icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
                                        <path d="M1 24.25a.79.79 0 01-.53-.22.73.73 0 01-.18-.76l1.88-5.84a.67.67 0 01.19-.3L18.47 1a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-16.23 16a.79.79 0 01-.29.18l-5.77 2a.67.67 0 01-.24.01zm2.55-6.19l-1.38 4.25 4.2-1.43L21.94 5.5 19 2.56 3.55 18.06z"></path>
                                        <path d="M20.38 8.68a.73.73 0 01-.53-.22L16 4.58a.75.75 0 010-1.06.77.77 0 011.07 0l3.88 3.88a.75.75 0 01-.57 1.28zM7.53 21.53a.74.74 0 01-.53-.22l-3.88-3.88a.75.75 0 111.06-1.06l3.88 3.88a.75.75 0 01-.53 1.28z"></path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                    );
                }
            }
            
        }
        
        return null;
    }

    renderProgressBar() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var user_personalisation = portal_context['user_personalisation'];

        var selected_program = this_component['state']['selected_program'];
        
        if (selected_program) {
            var show_progress_bar = false;
            
            // Build program requirements URL
            var params = [];
            var program_code = selected_program['code'];
            if (program_code) {
                params.push('programCode=' + program_code);
            }
            var teaching_periods = selected_program['teachingPeriods'];
            if (teaching_periods && teaching_periods.length > 0) {
                var term_code = teaching_periods[0]['code'];
                if (term_code) {
                    params.push('termCode=' + term_code);
                }
            }

            var check_requirements_url = helpers.getDynamicLinkUrlById('919957');
            if (params.length > 0) {
                check_requirements_url += '?' + params.join('&');
            }

            // Calculate progress from credit points
            var credit_points_achieved = selected_program['creditPointsAchieved'] ? selected_program['creditPointsAchieved'] : 0;
            var credit_points_target = selected_program['creditPointsTarget'];
            var percent_val = calculateCreditPointPercentage(credit_points_target, credit_points_achieved);
            var percent_complete = percent_val + '%';

            var progress_styles = {
                width: percent_complete
            };

            // Only show progress bar to PGRD and UGRD
            var progress_bar_audience = [{
                "audiences": [{"attr":{"CAREER":["PGRD","UGRD"]},"restrict":"Must"}]
            }];
            var audience_filtered = sq_personalise.fn.filterItems(progress_bar_audience, user_personalisation['attributes']);
            
            if (audience_filtered.length > 0) {
                
                // Show progress bar if user has credit point target
                if (typeof(credit_points_target) !== 'undefined') {
                    if (credit_points_target > 0) {
                        show_progress_bar = true;
                    }
                }
            }
            
            
            if (show_progress_bar) {

                //Build Max Complete Term
                var max_term_component = null;
                var max_term = selected_program['maxCompleteTerm'];
                if(max_term){
                    max_term_component = (
                        
                        <div className="progress-section__max-term__wrapper">
                            <div className="progress-section__separator"></div>
                        
                        <div className="progress-section__max-term__content-wrapper">
                            
                            <div className="progress-section__max-term__title">
                                Must Complete Program by the end of:
                            </div>
                            <div className="progress-section__max-term__content">
                                {max_term}
                            </div>
                        </div>
                        </div>
                    );
                }

                // Build GPA reveal
                var gpa_button = null;
                var show_gpa = this_component['state']['show_gpa'];
                var gpa_class = show_gpa ? ' progress-section__gpa__reveal--shown' : '';
                var gpa = selected_program['programGPA'];
                if (gpa) {
                    gpa_button = (
                        <div className="progress-section__gpa__wrapper">
                            <div className="progress-section__gpa__title">
                                PROGRAM GPA
                            </div>
                            <button className={"progress-section__gpa__reveal" + gpa_class} onClick={this_component.revealGPA}>
                                <span className="progress-section__gpa__reveal--background">
                                </span>
                                <span className="progress-section__gpa__reveal--gpa">
                                    {selected_program['programGPA']}
                                </span>
                                <span className="progress-section__gpa__reveal--toggle">
                                    <div className="progress-section__gpa__reveal--toggle--open">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                                            <path fill="#FFF" fillRule="evenodd" d="M13.34.848l.095.084a.997.997 0 01.005 1.41L8.485 7.296l4.955 4.954a.993.993 0 01.079 1.315l-.084.095a.997.997 0 01-1.41.005L7.071 8.71l-4.954 4.955a.994.994 0 01-1.41-.005.997.997 0 01-.005-1.41l4.955-4.954L.702 2.342A.994.994 0 01.707.932a.997.997 0 011.41-.005L7.07 5.882 12.025.927A.993.993 0 0113.34.848z"></path>
                                        </svg>
                                    </div>
                                    <div className="progress-section__gpa__reveal--toggle--closed">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="14" viewBox="0 0 29 14">
                                            <g fill="#FFF" fillRule="nonzero">
                                                <path d="M20.458 7.65a.684.684 0 0 1-.675-.675 5.625 5.625 0 0 0-5.625-5.625.675.675 0 0 1 0-1.35 6.984 6.984 0 0 1 6.975 6.975.684.684 0 0 1-.675.675z"></path>
                                                <path d="M14.158 13.95a6.975 6.975 0 0 1 0-13.95.675.675 0 0 1 0 1.35 5.625 5.625 0 1 0 5.625 5.625.675.675 0 0 1 1.35 0 6.984 6.984 0 0 1-6.975 6.975z"></path>
                                                <path d="M14.158 13.95C6.498 13.95.424 7.704.172 7.443a.675.675 0 0 1 0-.9C.424 6.282 6.472.036 14.158.036c7.686 0 13.734 6.246 13.986 6.507.23.256.23.644 0 .9-.252.261-6.327 6.507-13.986 6.507zM1.63 6.975C3.187 8.397 8.254 12.6 14.158 12.6c5.904 0 10.98-4.194 12.528-5.625-1.557-1.422-6.624-5.625-12.528-5.625-5.904 0-10.98 4.194-12.528 5.625z"></path>
                                                <path d="M16.516 7.65a.675.675 0 0 1-.666-.675 1.692 1.692 0 1 0-3.384 0c0 .37-.297.67-.666.675-.374 0-.68-.3-.684-.675a3.042 3.042 0 0 1 6.084 0 .684.684 0 0 1-.684.675z"></path>
                                                <path d="M11.8 6.075c.37.005.666.306.666.675a1.692 1.692 0 1 0 3.384 0c0-.37.297-.67.666-.675.374 0 .679.3.684.675a3.042 3.042 0 0 1-6.084 0 .684.684 0 0 1 .684-.675z"></path>
                                            </g>
                                        </svg>

                                    </div>
                                </span>
                            </button>
                            <div className="progress-section__gpa__reveal__title">
                                Reveal
                            </div>
                        </div>
                    );
                }

                // Get tooltip
                var tooltip = this_component.renderTooltip(percent_val);

                return (
                    <div className="progress-section__wrapper">
                        <div className="progress-section__main-wrapper">
                            <div className="progress-section__title">
                                Credit Point Tracker
                            </div>
                            <div className="progress-section__progress-bar"> 
                                <span className="progress-section__progress-bar__inner" style={progress_styles}></span>
                                {tooltip}
                            </div>
                            <div className="progress-section__program-details">
                                <div className="progress-section__credit-points">
                                    {credit_points_achieved} of {credit_points_target} credit points achieved to date
                                </div>
                                <a href={check_requirements_url} className="progress-section__program-requirements" target="_blank">
                                    On track for graduation? Check here
                                </a>
                            </div>
                            <div className="progress-section__separator"></div>
                        </div>
                        {gpa_button}
                        {max_term_component}
                    </div>
                );
            }
            
        }

        return null;
    }

    renderTooltip(percentage) {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var helpers = portal_context['helpers'];
        var current_page = portal_context['current_page'];
        var page_data = helpers.getPageBySlug(current_page);

        if (typeof page_data['content'] != 'undefined' && typeof page_data['content']['tooltips'] != 'undefined') {
            var tooltips = page_data['content']['tooltips'];
            var progress_bar_tooltips = tooltips['progress_bar'];

            if (progress_bar_tooltips) {
                var filtered_tooltips = sq_personalise.fn.filterItems(progress_bar_tooltips, user_personalisation['attributes']);

                if (filtered_tooltips.length > 0) {
                    var active_tooltip = filtered_tooltips[0];
                    var tooltip_style = {};

                    if (percentage < 50) {
                        var LHS_BOUND = -5;
                        var left_tooltip = percentage - 10;
                        
                        if (left_tooltip < LHS_BOUND) {
                            left_tooltip = LHS_BOUND;
                        }

                        tooltip_style = {
                            left: left_tooltip + '%'
                        };

                    } else {
                        var RHS_BOUND = -5;
                        var right_tooltip = (100 - percentage) - 10;

                        if (right_tooltip < RHS_BOUND) {
                            right_tooltip = RHS_BOUND;
                        }

                        tooltip_style = {
                            right: right_tooltip + '%',
                            left: 'auto'
                        };
                    }

                    return (
                        <div className="progress-section__progress-bar__modal">
                            <span className="triangle" style={{left: 'calc(' + percentage + '% - 7px)'}}></span>
                            <div className="progress-section__progress-bar__modal__dialogue" style={tooltip_style}>
                                {active_tooltip['message']}
                            </div>
                        </div>
                    );
                }
            }
            
        }
        
        return null;
    }




    //
    // Render
    //


    render() {
        var this_component = this;

        return (
            <>
                <ContextualMessage id="program_summary" />
                {this_component.renderMajorInfo()}
                {this_component.renderProgressBar()}
            </>
        );
    }

};

ProgressSection.contextType = PortalContext;

function calculateCreditPointPercentage(credit_points_target, credit_points_achieved) {

    let percentage = 0;

    if (credit_points_target < credit_points_achieved) {
        // set as 1 for when we multiply by 100
        percentage = 1;
    } else if (credit_points_achieved < 0) {
        percentage = 0;
    } else {
        percentage = credit_points_achieved / credit_points_target;
    }

    return Math.round(percentage * 100);
}